export default "__VITE_PUBLIC_ASSET__377855bd__"